import { Decimal } from 'decimal.js-light';
import { IReferenceObjectValue } from '../references/IReference';

export type ExpressionValue =
  // Risultati primitivi
  | string
  | number
  | boolean
  | Date
  | null
  // Valute
  | Decimal
  // Un array di oggetti
  | IReferenceObjectValue[]
  // Risultato primitivo per un `in`
  | string[]
  | number[];

export function isPlainArray(
  value: ExpressionValue,
): value is string[] | number[] {
  if (!Array.isArray(value)) return false;
  if (value.length === 0) return true;
  return (value as any).every(
    (item: any) => typeof item === 'string' || typeof item === 'number',
  );
}
